/**
 * Guard for colour values that come from the database and end up in an inline
 * style (image placeholders, list tints).
 *
 * Assigning to `element.style.background` can't inject a second declaration —
 * the browser rejects the whole value — but it *can* accept `url(...)`, which
 * turns a colour column into an outbound request to whatever host the value
 * names. In a shared household that is a member-writable field rendering in
 * everyone else's browser, so only shapes we actually use are allowed through:
 * a hex colour or a design-token reference.
 */
const SAFE_COLOR = /^(#[0-9a-fA-F]{3,8}|var\(--[a-zA-Z0-9-]+\))$/

export function safeCssColor(value: string | null | undefined): string | null {
  if (!value) return null
  const trimmed = value.trim()
  return SAFE_COLOR.test(trimmed) ? trimmed : null
}
